/* eslint-disable no-plusplus */
/* eslint-disable security/detect-object-injection */

export const CamelCase = (str) => str && str?.replace(/([A-Z])/g, ' $1').replace(/^./, (strng) => strng.toUpperCase());

export const TitleCase = (str) => {
    const splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
};

export const PriceHandler=(price)=>
    Number(price||0)?.toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
    })
